/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProducts200ResponseItemsInnerSchedulesInnerDaysInner
 */
export interface GetProducts200ResponseItemsInnerSchedulesInnerDaysInner {
}

/**
 * Check if a given object implements the GetProducts200ResponseItemsInnerSchedulesInnerDaysInner interface.
 */
export function instanceOfGetProducts200ResponseItemsInnerSchedulesInnerDaysInner(value: object): value is GetProducts200ResponseItemsInnerSchedulesInnerDaysInner {
    return true;
}

export function GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerFromJSON(json: any): GetProducts200ResponseItemsInnerSchedulesInnerDaysInner {
    return GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerFromJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200ResponseItemsInnerSchedulesInnerDaysInner {
    return json;
}

export function GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerToJSON(json: any): GetProducts200ResponseItemsInnerSchedulesInnerDaysInner {
    return GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerToJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerToJSONTyped(value?: GetProducts200ResponseItemsInnerSchedulesInnerDaysInner | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

